module.exports = __webpack_public_path__ + "main/images/signup/paper-airplane-illus.acbbd472cf3ba5a658944bb8de82f45a.svg";